/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetGachaInstanceResponse } from '../../models/get-gacha-instance-response';

export interface GachaServiceGetGachaInstance$Params {
  gachaInstanceId: string;
}

export function gachaServiceGetGachaInstance(http: HttpClient, rootUrl: string, params: GachaServiceGetGachaInstance$Params, context?: HttpContext): Observable<StrictHttpResponse<GetGachaInstanceResponse>> {
  const rb = new RequestBuilder(rootUrl, gachaServiceGetGachaInstance.PATH, 'get');
  if (params) {
    rb.path('gachaInstanceId', params.gachaInstanceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetGachaInstanceResponse>;
    })
  );
}

gachaServiceGetGachaInstance.PATH = '/api/v3/gateway/gacha/instance/{gachaInstanceId}';
